export const paymentMethods = {
  name: '付款方式',
  edit_title: '編輯付款方式',
  fields: {
    search: '搜尋',
    code: '代碼',
    name: '名稱',
    type: '類型',
    gateway: '支付網關',
    icon_key: '圖示代碼',
    device_type: '裝置類型',
    is_active: '啟用',
    sort_order: '排序',
    supports_tokenization: '可儲存',
    gateway_method_code: '網關代碼',
    display_name: '顯示名稱',
    description: '描述',
    created_at: '建立時間',
    updated_at: '更新時間',
  },
  types: {
    card: '信用卡',
    ewallet: '電子錢包',
    mobile_wallet: '手機錢包',
  },
  device_types: {
    all: '所有裝置',
    ios: '僅 iOS',
    android: '僅 Android',
  },
  sections: {
    basic_settings: '基本設定',
    gateway_settings: '網關設定',
    translations: '翻譯',
    read_only: '唯讀資訊',
  },
  hints: {
    drag_to_reorder: '拖曳以重新排序',
    is_active: '停用後，此付款方式將不會顯示在應用程式中',
    sort_order: '數字越小越靠前',
    icon_key: '手機應用程式使用的圖示識別碼',
    gateway: '選擇處理此付款方式的支付網關',
    edit_info: '修改付款方式設定。變更將立即生效。',
  },
};

export const paymentMethodsResource = {
  ...paymentMethods,
};
